import PortalAppService from "../../../application/platform/portal-app-service";
import { IContactUsRequest } from "../../../model/base/request/contact-us-request";
import { ACTION_TYPES, useContactDispatch } from "./contact-context";

export const useContactController = () => {
    const dispatch = useContactDispatch();

    const sendMessage = async (request: IContactUsRequest) => {
        try {
            dispatch({ type: ACTION_TYPES.SET_LOADING, payload: true });
            await PortalAppService.sendContactMessage(request);
            dispatch({ type: ACTION_TYPES.SET_SUCCESS, payload: true });
        } catch (error: any) {
            dispatch({ type: ACTION_TYPES.SET_ERROR, payload: error?.message || 'Erro ao enviar mensagem' });
        }
    };

    const resetState = () => {
        dispatch({ type: ACTION_TYPES.RESET_STATE });
    };

    return {
        sendMessage,
        resetState
    };
};
